<template>
  <ux-modal
    class="change-email"
    width="720px"
    v-model="showModal"
    :title="$t('HT.changeEmail')"
    :close="hideModal"
  >
    <div class="changeemail-cont">
      <!-- 进度条 -->
      <div class="changeemail-stepbox">
        <ux-steps :active="step" direction="vertical">
          <ux-step v-for="(item, idx) in stepSideList" :key="item" :title="item"></ux-step>
        </ux-steps>
      </div>
      <!-- 右侧内容 -->
      <div class="changeemail-verify">
        <ux-form
          v-if="step !== 3"
          class="my-vertical-form"
          ref="form"
          :rules="rules"
          :data="formData"
          hide-btn
          width="232px"
          hideRequired
        >
          <!-- 第一步 -->
          <template v-if="step === 1">
            <!-- 账号名称 -->
            <ux-form-item :label="$t('HT.changeEmail.username')" key="username">
              <div class="changephone-verify-item">
                <div class="verify-control color-text">
                  {{ username }}
                </div>
              </div>
            </ux-form-item>
            <!-- 当前邮箱 -->
            <ux-form-item
              :label="$t('HT.changeEmail.currenEmail')"
              prop="oldEmail"
              key="oldEmail"
              :error="errorList.oldEmail"
            >
              <ux-input
                noSpace
                v-model="formData.oldEmail"
                :placeholder="$t('HT.changeEmail.placeholder')"
              ></ux-input>
            </ux-form-item>
          </template>

          <!-- 第二步 -->
          <template v-if="step === 2">
            <!-- 新邮箱 -->
            <ux-form-item :label="$t('HT.changeEmail.newEmail')" prop="email" key="email" :error="errorList.email">
              <ux-input noSpace v-model="formData.email" :placeholder="$t('HT.rules.changeEmail.oldEmail')"></ux-input>
            </ux-form-item>

            <!-- 图形验证码 -->
            <ux-form-item
              :label="$t('HT.imgcode')"
              prop="imgCode"
              key="imgCode"
              :error="errorList.imgCode"
            >
              <ux-input
                noSpace
                v-model="formData.imgCode"
                :placeholder="$t('HT.imgcode')"
                class="min-input"
              ></ux-input>
              <img-verify ref="refImgVerify" v-model="prefix" />
            </ux-form-item>

            <ux-form-item :label="$t('HT.code')" prop="code" key="code" :error="errorList.code">
              <ux-input
                noSpace
                class="min-input"
                v-model="formData.code"
                :placeholder="$t('HT.code')"
                :regular="regPositiveInteger"
              ></ux-input>
              <time-button ref="time" text :time="120" @click="getCode"></time-button>
            </ux-form-item>
          </template>
        </ux-form>

        <!-- 第三步 -->
        <template v-else>
          <div class="change-email-result result-success"></div>
          <div class="result-msg">
            {{$t('HT.changeEmail.result.left')}} <span>{{ this.formData.email }}</span> {{$t('HT.changeEmail.result.right')}}
          </div>
        </template>
      </div>
    </div>
    <template slot="footer">
      <div class="changeemail-footer">
        <ux-button v-show="!hideClose" plain @click="close">{{ closeText }}</ux-button>
        <ux-button type="primary" @click="confirm">{{ confirmText }}</ux-button>
      </div>
    </template>
  </ux-modal>
</template>

<script>
import { rules } from '@l/rules.js';
import timeButton from '@/views/template/timeButton';
import imgVerify from '@c/imgVerify/imgVerify';

export default {
  name: 'ChangeEmail',
  components: {
    timeButton,
    imgVerify
  },
  props: {
    // 用户名
    username: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      step: 1, // 第几步
      showModal: false,
      stepSideList: [this.$t('HT.resetPass.check'), this.$t('HT.changeEmail.bind'), this.$t('HT.purchaseApi.step3')],
      regPositiveInteger: rules.noZeroInteger().pattern, // 不包括0正整数
      rules: this.$rul.changeEmail(),
      formData: {
        oldEmail: '',
        email: '',
        code: '',
        imgCode: ''
      },
      // 错误信息
      errorList: {
        oldEmail: '',
        email: '',
        code: '',
        imgCode: ''
      },
      prefix: '' // 图形验证码前缀
    };
  },
  computed: {
    // 确认按钮文案
    confirmText() {
      const step = this.step;
      if (step === 2) {
        return this.$t('HT.changeEmail.edit');
      }
      if (step === 3) {
        return this.$t('HT.purchaseApi.step3');
      }
      return this.$t('HT.addApi.nextStep');
    },
    // 关闭按钮文案
    closeText() {
      return this.step === 2 ? this.$t('HT.addApi.prevStep') : this.$t('HT.cancel');
    },
    // 隐藏关闭按钮
    hideClose() {
      return this.step === 3;
    }
  },
  created() {
    this.$nextTick(() => {
      this.showModal = true;
    });
  },

  methods: {
    /**
     * 获取验证码
     */
    getCode() {
      const errList = [];
      this.$refs['form'].validateField(['email'], (res) => {
        if (res) {
          errList.push(res);
        }
      });

      const { imgCode, email } = this.formData;

      if (!imgCode) {
        this.errorList.imgCode = this.$t('HT.login.imgCode.placeholder');
        return;
      }

      if (errList.length === 0) {
        this.$uxLoading.show();
        this.clearErrorMsg();
        const params = {
          email,
          code: imgCode,
          prefix: this.prefix
        };
        this.$api.user
          .getChangeEmailCode(params, { hideMsg: true })
          .then((res) => {
            if (res.code == 10000) {
              this.$refs.time.start();
            }
          })
          .catch((err) => {
            const { sub_msg } = err.response.data;
            this.errorList.code = sub_msg;
            this.$refs.refImgVerify.getKaptcha();
            this.formData.imgCode = '';
          });
      }
    },

    /**
     * 验证邮箱
     */
    personIdentify() {
      this.$uxLoading.show();
      this.clearErrorMsg();
      this.$api.user
        .identifyChangeEmail({ email: this.formData.oldEmail }, { hideMsg: true })
        .then((res) => {
          if (res.code == 10000) {
            this.step++;
          }
        })
        .catch((err) => {
          const { sub_msg } = err.response.data;
          this.errorList.oldEmail = sub_msg;
        });
    },

    // 修改邮箱
    personEmail() {
      const { code, email } = this.formData;
      const params = {
        code,
        email
      };
      this.$uxLoading.show();
      this.clearErrorMsg();
      this.$api.user
        .changeEmail(params, { hideMsg: true })
        .then((res) => {
          if (res.code == 10000) {
            this.$uxMessage.success(this.$t('HT.addApi.editSuccess2'));
            this.$emit('update-info');
            this.step++;
          }
        })
        .catch((err) => {
          const { sub_msg, sub_code } = err.response.data;
          const emailCode = ['error.email', 'existing.email'];
          if (emailCode.includes(sub_code)) {
            // 邮箱错误
            this.errorList.email = sub_msg;
          } else {
            // 验证码错误
            this.formData.code = '';
            this.$nextTick(() => {
              this.errorList.code = this.$t('HT.login.text2');
            });
          }
        });
    },

    /**
     * 清空错误信息
     */
    clearErrorMsg() {
      for (const key in this.errorList) {
        if (Object.hasOwnProperty.call(this.errorList, key)) {
          this.errorList[key] = '';
        }
      }
    },

    /**
     * 关闭弹窗
     */
    hideModal() {
      this.showModal = false;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
        this.$emit('close');
      }, 500);
    },
    /**
     * 取消回调
     */
    close() {
      const step = this.step;
      if (step == 1) {
        return this.hideModal();
      }
      this.step--;
    },

    /**
     * 确认回调
     */
    confirm() {
      const step = this.step;
      if (step == 3) {
        this.hideModal();
        return;
      }

      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (step === 1) {
            this.personIdentify();
            return;
          }
          if (step === 2) {
            this.personEmail();
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.changeemail-cont {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-top: 40px;

  .changeemail-stepbox {
    position: relative;
    width: 232px;
    flex: 0 0 auto;
    box-sizing: border-box;
    border-right: 1px solid $color-disable;
    padding-left: 40px;
    padding-bottom: 20px;
    height: 206px;
  }

  .changeemail-verify {
    position: relative;
    flex: 1;
    padding-left: 66px;

    .changeemail-errorbox {
      color: $color-error;
    }

    .changeemail-verify-item {
      width: 200px;
      margin-bottom: 24px;
      color: $color-text-secondary;

      &:last-of-type {
        margin-bottom: 0;
      }

      .verify-label {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-size: 12px;
        height: 16px;
        color: $color-text-secondary;
      }

      .verify-control {
        display: flex;
        align-items: center;
        color: $color-title;
        height: 32px;

        &.verify-code {
          justify-content: flex-start;

          .ux-input {
            width: 96px;
          }
        }
      }
    }

    .time-button {
      margin-left: 24px;
    }

    .min-input {
      width: 110px;
      margin-right: 20px;
    }

    .change-email-result {
      position: relative;
      display: block;
      margin: 16px auto 24px;
      width: 120px;
      height: 100px;
    }

    .result-msg {
      height: 20px;
      font-weight: 400;
      color: $color-text;
      line-height: 20px;
      text-align: center;
      color: $color-text;

      span {
        color: $color-primary;
      }
    }
  }
}

.changeemail-footer {
  text-align: right;
  padding-top: 32px;

  .ux-button {
    margin-left: 8px;
  }
}
</style>
